<form [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" (submit)="save()" *ngIf="fields && form">

  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">

      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{ 'calendarList.calendar_groups' | translate }}</h1>
      </div>

      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/calendargroups" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" type="submit" icon="fa fa-floppy-o" iconPos="left"
                label="{{ 'common.save' | translate }}"></button>
      </div>

    </div>


    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</span>
          <input type="text" pInputText [maxlength]="fields.code.width" class="fieldInput" formControlName="code">
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText [maxlength]="fields.description.width" class="fieldInput" formControlName="description">
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="editMode && calendarGroupItems">

      <div class="ui-g ui-fluid">
        <span class="label">{{ 'calendarList.calendar' | translate }}</span>
        <button pTooltip="Add Item" pButton class="k-generic-btn" type="button" icon="fa fa-plus" iconPos="center" style="float: right; margin-left: 10px;" (click)="openAddItemDialog();"></button>
      </div>

      <div class="ui-g ui-fluid" *ngFor="let groupItem of calendarGroupItems; let i=index">
        <p-panel class="ui-g-12">
          <p-header>
            <div class="ui-helper-clearfix">
              <span class="ui-panel-title">#{{ i }}</span>
              <button pTooltip="Delete Item" pButton type="button" (click)="deleteGroupItem(groupItem)" icon="fa fa-times" iconPos="center" class="ui-button-danger btnDelete slim"></button>
            </div>
          </p-header>
          <div class="ui-g-12  ui-fluid">
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ 'calendarGroupList.calendarGroup' | translate }}</span>
              {{ groupItem.group_code }} - {{ groupItem.group_description }}
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ 'calendarList.calendar' | translate }}</span>
              {{ groupItem.item_code }} - {{ groupItem.item_description }}
            </div>
          </div>
          <p-footer class="clearfix">&nbsp;</p-footer>
        </p-panel>
      </div>
    </div>

  </div>

  <p-dialog *ngIf="addItemDialog"
          [width]="500"
          [(visible)]="addItemDialog"
          showEffect="fade"
          [modal]="true"
          (onHide)="closeDialog()">

          <calendar-group-item-form
              [calendarGroupId]="calendarGroupId"
              (calendarGroupItemAdded)="calendarGroupItemAdded()">
          </calendar-group-item-form>
</p-dialog>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/form-calendar-group/form-calendar-group.component.html